export const getConfiguration = (state) => {
  const { configuration } = state;
  return configuration;
};


export const getApiServerUrl = (state) => {
  const { apiServerBaseUrl } = getConfiguration(state);

  return apiServerBaseUrl;
};


export const getGraphQLUrl = (state) => {
  const apiServerBaseUrl = getApiServerUrl(state);
  const graphQLUrl = `${apiServerBaseUrl}/graphql`;

  return graphQLUrl;
};


export const getSignInUrl = (state) => {
  const apiServerBaseUrl = getApiServerUrl(state);
  const signInUrl = `${apiServerBaseUrl}/auth/sign_in`;

  return signInUrl;
};


export const getPasswordResetUrl = (state) => {
  const apiServerBaseUrl = getApiServerUrl(state);
  const passwordResetUrl = `${apiServerBaseUrl}/auth/password`;

  return passwordResetUrl;
};


export const getSubmissionPhoneNumber = (state) => {
  const { submissionPhoneNumber } = getConfiguration(state);

  return submissionPhoneNumber;
};


export const getSubmissionEmailAddress = (state) => {
  const { submissionEmailAddress } = getConfiguration(state);

  return submissionEmailAddress;
};


export const getMobilePasswordUrl = (state) => {
  const apiServerBaseUrl = getApiServerUrl(state);
  const mobilePasswordUrl = `${apiServerBaseUrl}/auth/create_onetime_password`;

  return mobilePasswordUrl;
};


export const getEnvironmentColor = (state) => {
  const { environmentColor } = getConfiguration(state);

  /* NOTE: Normal bootstrap style */
  if (!environmentColor) {
    return '#f8f8f8';
  }

  return environmentColor;
};


export const getAnalyticsTrackerId = (state) => {
  const { analyticsTrackerId } = getConfiguration(state);

  return analyticsTrackerId;
};


export const enableLookupFeature = (state) => {
  return true;
};
